import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';
import Section from '../Section';

import styles from './arrowSection.module.scss';

function ArrowSection(props) {
  const {
    cta,
    content,
    image,
    title,
  } = props;
  return (
    <Section size="small" fullBleed>
      <div className={styles.wrapper}>
        <div className={styles.column}>
          <div className={styles.content}>
            {title && (
              <h2 className={styles.title}>{title}</h2>
            )}

            {content && (
              <div dangerouslySetInnerHTML={{ __html: content.childMarkdownRemark.html }} className={styles.text} />
            )}

            {cta && (
              <Button
                {...cta}
                modifierclass={styles.btn}
                link={cta.url}
                isMobileFull
              >
                {cta.label}
              </Button>
            )}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.image} style={{ backgroundImage: `url(${image.file.url})` }} />
        </div>
        <div className={styles.arrow} />
      </div>
    </Section>
  );
}

export default ArrowSection;


ArrowSection.propTypes = {
  content: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string,
    }),
  }),
  cta: PropTypes.shape({
    url: PropTypes.string,
    istargetblank: PropTypes.bool,
    gtmEventName: PropTypes.string,
    gtmEventType: PropTypes.string,
    label: PropTypes.string,
    variant: PropTypes.string,
  }),
  image: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
    }),
  }),
  title: PropTypes.string,
};


ArrowSection.defaultProps = {
  content: null,
  cta: null,
  image: null,
  title: '',
};
